var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOperations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1-2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13016",
    "data-name": "Path 13016",
    d: "M15.6,16H2.4A2.374,2.374,0,0,1,0,13.653V5.576A2.374,2.374,0,0,1,2.4,3.229H4.953V1.212A1.226,1.226,0,0,1,6.192,0h5.617a1.226,1.226,0,0,1,1.238,1.212V3.229H15.6A2.374,2.374,0,0,1,18,5.576v8.078A2.374,2.374,0,0,1,15.6,16ZM2.4,4.684a.9.9,0,0,0-.911.892v8.078a.9.9,0,0,0,.911.892H15.6a.9.9,0,0,0,.911-.892V5.576a.9.9,0,0,0-.911-.892H12.3v0ZM6.439,3.229h5.122V1.455H6.439Z",
    fill: "#868a97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperations);
export default __webpack_public_path__ + "static/media/operations.6dda682a0202c19a6632b439af6828de.svg";
export { ForwardRef as ReactComponent };